import React from "react";
import {Button, Checkbox, Form, Icon, Input, message, Row, Col, Typography} from "antd";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import axios from 'axios';

import { API_PATH } from '../constants/ApiPath'
import "./signin.less"

import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;
const { Text, Title } = Typography;

class ResetPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    access_token : '',
    cloader:false,
  };


  }

  handleSubmit = (e) => {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('token')
    // console.log('ths========', token)
    e.preventDefault();
    this.props.form.validateFields((err, values) => {

      if (!err) {
      this.setState({cloader: true});
       const user = {
        password1: values.newPassword,
        password2:values.confirmPassword,
        token:token
      };
      const headers ={
        'Content-Type': 'application/json',
        'Accept': 'application/json',

      }
      const endpoint = '/partner/password-reset-confirm/'
      axios.post(API_PATH.concat(endpoint), user , {headers})
      .then(res => {
        //console.log('res------------', res)
        if (res.data['status'] === 200)
        {
          message.success(res.data['message'])
          this.setState({cloader: false});
          this.props.history.push('/signin')
        }else {
          this.setState({cloader: false});
          message.error(res.data['message'])
        }
      })
      .catch(error => {
        this.setState({cloader: false});
        message.error(error.toString())

      });

      }
    });
  };




  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <Row type="flex" align="middle" className="gx-app-login-main-content">
              <Col xl={12} lg={24} md={24} sm={24} xs={24} className="emptySpacing">
                <div className="gx-app-logo-content">
                  <div className="gx-app-logo-content-bg">
                    <img src={require('assets/images/jetty-welcome-cropped.jpg')} alt='Neature'/>
                  </div>
                </div>
              </Col>
              <Col xl={12} lg={24} md={24} sm={24} xs={24} className="emptySpacing">
                <div className="gx-app-login-content">
                  <Title level={2}>Reset Password</Title>
                  <Text style={{fontSize:'18px'}}>Please enter your new password and reset here.</Text>
                  <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0 gx-mt-4">

                    <FormItem
                    label={(
                      <span>
                      New Password
                    </span>
                    )}
                    >
                      {getFieldDecorator('newPassword', {
                        initialValue: "",
                        rules: [{
                          required: true,  message: 'Please input Password!',
                        }],
                      })(
                        <Input type="password"  placeholder="New Password"/>
                      )}

                    </FormItem>
                    <FormItem
                    label={(
                      <span>
                      Confirm Password
                    </span>
                    )}
                    >
                      {getFieldDecorator('confirmPassword', {
                        initialValue: "",
                        rules: [{
                          required: true,  message: 'Please confirm the Password!',
                        }],
                      })(
                        <Input type="password"  placeholder="Confirm Password"/>
                      )}
                    </FormItem>
                    <br></br>
                    <FormItem>
                    <Button type="primary" className="gx-mb-0" htmlType="submit">Reset Password</Button>
                    <span><IntlMessages id="app.userAuth.or"/></span>  <Link to="/signin"><IntlMessages
                      id="app.userAuth.skip"/></Link>
                    </FormItem>
                  </Form>
                </div>
                {this.state.cloader ?
                  <div className="gx-loader-view">
                    <CircularProgress/>
                  </div> : null}
              </Col>
          </Row>
        </div>
      </div>

    );
  }
}

const WrappedNormalLoginForm = Form.create()(ResetPassword);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser, logedInUser} = auth;
  return {loader, alertMessage, showMessage, authUser, logedInUser}
};

export default connect(mapStateToProps,)(WrappedNormalLoginForm);
